
import { ApiService }                    from '../api/api.service';
import { SessionService }             from '../sessions/session.service';
import { TillpaymentsSettingsComponent } from './tillpayments.settings.component';

export const TillpaymentsStates : Array<any> = [
  {
    component: TillpaymentsSettingsComponent,
    name     : 'app.tillpayments-settings',
    url      : '/tillpayments-settings',
    resolve  : [
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) => sessionService.refresh(),
        token    : 'session'
      },
      {
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) => apiService.get('/company_integrations'),
        token    : 'settings'
      }
    ]
  }
];
